import { useQuery } from '@tanstack/react-query';
import { useGraphneAPI } from '@nexelem/graphne-api';
import { RequestFormatters } from '@nexelem/utils';

export const GRAPHNE_RESOURCE_GROUP_LIST_TIMEFRAME_KEY = 'graphne_resource_group_list_timeframe_key';

type Params = {
  resourceGroupId: string;
  from?: Date;
  to?: Date;
  search?: string;
};

export const useGraphneResourcesGroupTimeframe = ({ resourceGroupId, from, to, search }: Params, enabled?: boolean) => {
  const api = useGraphneAPI();

  return useQuery({
    queryKey: [GRAPHNE_RESOURCE_GROUP_LIST_TIMEFRAME_KEY, resourceGroupId, from?.toString(), to?.toString(), search],
    queryFn: () =>
      api.postGraphneResourcesGroupTimeframeResourcegroupid({
        resourceGroupId,
        getGroupDetailsFilter: {
          ...RequestFormatters.date.dateTimeRange({ from, to }),
          resourceSearch: search,
        },
      }),
    enabled,
  });
};
